// extracted by mini-css-extract-plugin
module.exports = {"select-popup-container":"VIP_SelectPopup__select-popup-container","selectPopupContainer":"VIP_SelectPopup__select-popup-container"};